import React from 'react';
import { mockApproach } from '../mock';

const ApproachSection = () => {
  return (
    <section id="approach" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4">
            Our Approach
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Simple. Transparent. Effective.
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          {mockApproach.map((step, index) => (
            <div
              key={step.id}
              className="flex flex-col md:flex-row gap-6 mb-8 group"
            >
              {/* Step Number */}
              <div className="flex-shrink-0">
                <div className="w-20 h-20 bg-orange-600 rounded-full flex items-center justify-center text-white text-2xl font-bold group-hover:scale-110 transition-transform duration-300 shadow-lg">
                  {step.step}
                </div>
              </div>

              {/* Step Content */}
              <div className="flex-1 bg-gray-50 rounded-lg p-6 group-hover:bg-blue-50 group-hover:shadow-lg transition-all duration-300">
                <h3 className="text-2xl font-bold text-blue-900 mb-2">
                  {step.title}
                </h3>
                <p className="text-gray-700 text-lg">{step.description}</p>
              </div>

              {/* Connector Line (except for last item) */}
              {index < mockApproach.length - 1 && (
                <div className="hidden md:block absolute left-10 w-0.5 h-20 bg-orange-300 ml-10" style={{ marginTop: '80px' }}></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ApproachSection;